import { css } from '@emotion/react'

import { breakpoint, size, width } from '@twisto/styles'

export const modalWrapper = css`
  max-width: ${width.modal.compact};
`

export const modalContent = css`
  padding: ${size[48]} ${size[80]};

  ${breakpoint.down('xs')} {
    padding: ${size[32]} ${size[24]};
  }
`

export const buttonGroup = css`
  grid-template-columns: 1fr 1fr;
  margin-top: ${size[32]};
`

export const pepDescriptionButton = css`
  text-align: center;
  margin-top: ${size[16]};
  width: 100%;
`
